import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_6: FaireProductEntity = {
  token: "ramen-6",
  type: "product",
  name: "Omiso Soup Ball Gift",
  brandName: "Omiso",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/917e02363bab62313d68d7431bcf70e65fd8eff5fa31e9abccafe979d12106d2.png",
  priceDollars: 34,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/917e02363bab62313d68d7431bcf70e65fd8eff5fa31e9abccafe979d12106d2.png",
  weight: 0.4,
  dimensions: {
    width: 6,
    height: 6,
    depth: 3,
  },
  description: "Omiso soup ball gift set for ramen preparation",
  categoryTokens: ["cat_food-snacks"],
  tags: ["ramen", "japanese-ramen", "miso", "soup", "gift-set", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
